var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 18,
    viewBox: "0 0 55 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6196_23231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8323 17.7404H19.377L22.1637 0.315918H26.6188L23.8323 17.7404Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9841 0.741829C39.1053 0.38927 37.7114 0 35.9879 0C31.5881 0 28.4898 2.37257 28.4708 5.76463C28.4342 8.26729 30.6891 9.65733 32.3755 10.4918C34.0993 11.3445 34.6852 11.901 34.6852 12.6611C34.6677 13.8284 33.2923 14.3665 32.0096 14.3665C30.2308 14.3665 29.2777 14.0891 27.8293 13.4396L27.2426 13.1612L26.6191 17.0727C27.6641 17.5541 29.5893 17.9813 31.5881 18C36.263 18 39.3065 15.6641 39.3426 12.0494C39.3604 10.0658 38.1697 8.54594 35.6028 7.30397C34.0445 6.50671 33.0901 5.96912 33.0901 5.15338C33.1084 4.4118 33.8973 3.65223 35.6564 3.65223C37.1048 3.61503 38.169 3.9671 38.9752 4.31941L39.3782 4.50444L39.9841 0.741829Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9069 11.5675C46.2738 10.5665 47.6857 6.6923 47.6857 6.6923C47.6672 6.7295 48.0519 5.6728 48.2719 5.0241L48.5832 6.5255C48.5832 6.5255 49.4269 10.6963 49.6102 11.5675C48.9138 11.5675 46.7869 11.5675 45.9069 11.5675ZM51.4065 0.315918H47.9603C46.8975 0.315918 46.0901 0.630783 45.6316 1.76163L39.0137 17.7402H43.6886C43.6886 17.7402 44.4582 15.5896 44.6237 15.1264C45.1365 15.1264 49.6842 15.1264 50.344 15.1264C50.4719 15.7381 50.8756 17.7402 50.8756 17.7402H55.0009L51.4065 0.315918Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6562 0.315918L11.2929 12.1977L10.8161 9.78797C10.0094 7.00741 7.47951 3.98638 4.65625 2.48425L8.65287 17.7219H13.3643L20.3674 0.315918H15.6562Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24161 0.315918H0.0733343L0 0.667985C5.59171 2.11395 9.29498 5.59938 10.8165 9.78871L9.2582 1.7806C9.00165 0.667738 8.21324 0.352628 7.24161 0.315918Z",
    fill: "#FAA61A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6196_23231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.51bfbaf7bb3c663f483eec222f765752.svg";
export { ForwardRef as ReactComponent };